/**
 * Authorization Roles
 */
const authRoles = {
	superAdmin: ['superAdmin'],
	admin: ['admin', 'superAdmin'],
	user: ['superAdmin', 'admin', 'user'],
	onlyGuest: []
};

export default authRoles;
